export default __webpack_public_path__ + "static/media/confusionImg_4.5a1cfd50.png";